import { Injectable } from '@angular/core';
import {
    NzNotificationPlacement,
    NzNotificationService,
} from 'ng-zorro-antd/notification';
import { LoggerService } from './logger/logger.service';

@Injectable({
    providedIn: 'root',
})
export class NotificationService {
    PLACEMENT: NzNotificationPlacement = 'topRight';
    DURATION: number = 3000;

    constructor(
        private notification: NzNotificationService,
        private logger: LoggerService
    ) {}

    public blank(title: string, message: string): void {
        this.notification.blank(title, message, {
            nzDuration: this.DURATION,
            nzPlacement: this.PLACEMENT,
        });
    }

    /**
     *  Show error notification and log error
     * @param title
     * @param message
     */
    public error(title: string, message: string): void {
        this.logger.error(title, message);
        this.notification.error(title, message, {
            // make error stay longer
            nzDuration: 5000,
            nzPlacement: this.PLACEMENT,
        });
    }

    public success(title: string, message: string): void {
        this.notification.success(title, message, {
            nzDuration: this.DURATION,
            nzPlacement: this.PLACEMENT,
        });
    }

    public warning(title: string, message: string): void {
        this.notification.warning(title, message, {
            nzDuration: this.DURATION,
            nzPlacement: this.PLACEMENT,
        });
    }
}
